import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import {
  MenuItem,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { GET_USER_AND_PROFESSIONS_QUERY } from "../../queries/queries";
import { UPDATE_USER } from "../../queries/mutations";
import { CHANGE_PASSWORD } from "../../queries/mutations";
import { DELETE_USER } from "../../queries/mutations";
import Loading from "../loading";
import Error from "../error";
import ModalPortal from "../shared/modal-portal";
import DeleteModal from "./DeleteModal";
import editIcon from '../../assets/images/edit.svg';
import Approvals from "./approvals";
import ProfilePharmacyModal from './profile-pharmacy-modal';
import backArrow from '../../assets/images/left_arrow.png';

const styles = (theme) => ({
  root: {
    backgroundColor: "#fff",
    color: "#fff",
    padding: 20,
    borderRadius: "0 0 0 60px",
  },
  submitBtn: {
    marginTop: 20,
  },
  formControl: {
    marginBottom: theme.spacing ? theme.spacing(1) : "8px",
    marginTop: theme.spacing ? theme.spacing(2) : "16px",
  },
  textfield: {
    marginBottom: 5,
  },
  editContainer: {
    margin: 20,
    marginTop: 150,
  },
  button: {
    marginTop: 50,
    backgroundColor: "#7FC5ED",
    borderRadius: 30,
    width: 240,
    height: 56,
    color: "#fff",
    fontWeight: "bold",
  },
  newPasswordButton: {
    backgroundColor: "inherit",
    color: "gray",
    marginTop: 20,
  },
  nextIcon: {
    marginLeft: 10,
  },
  buttonText: {
    margin: 0,
    fontSize: 16,
    fontWeight: "bold",
  },
  buttonBottom: {
    marginBottom: 24,
  },
  backIcon: {
    zIndex: 200,
    position: "absolute",
    left: 24,
    top: 40,
    color: "#fff",
  },
});

const Edit = ({ classes, handleLogOut }) => {
  let history = useHistory();
  const [showBanner, setShowBanner] = useState(false);
  const [id, setId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [professionId, setProfessionId] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const [open, setOpen] = React.useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [hasRequestedChange, setHasRequestedChange] = useState(false);


  const handleClose = (value) => {
    setOpen(false);
  };

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });

  const handleBack = () => {
    history.goBack() 
  };

  const { loading, error, data } = useQuery(GET_USER_AND_PROFESSIONS_QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      const professionId =
        data.currentUser.profession && data.currentUser.profession.id;
      setId(data.currentUser.id);
      setFirstName(data.currentUser.firstName);
      setLastName(data.currentUser.lastName);
      setEmail(data.currentUser.email);
      setProfessionId(professionId);
    },
  });

  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted(data) {
      setErrorMessage(null);
      setSuccessMessage("Erfolgreich gespeichert");
      history.push(`/profile`);
    },
    onError: (data) => {
      setSuccessMessage(null);
      setErrorMessage(data.graphQLErrors[0].message);
    },
  });

  const [deleteUser] = useMutation(DELETE_USER, {
    onCompleted(data) {
      localStorage.clear();
      // TODO: Delete the user's device token from the backend (deleteDeviceToken mutation)
      setShowDelete(false);
      history.push(`/registration`);
    },
  });

  const onDeleteUser = () => {
    console.log("click");
    setShowDelete(true);
  };

  const [changePassword] = useMutation(CHANGE_PASSWORD, {
    onCompleted(data) {
      setOpen(true);
    },
    onError: (data) => {
      setSuccessMessage(null);
      setErrorMessage("Leider ist ein Fehler aufgetreten");
    },
  });

  useEffect(() => {
    if (data?.currentUser?.openPharmacyChangeRequest) {
      setHasRequestedChange(true);
    }
  }, [data]);

  if (loading) return <Loading />;
  if (error) return <Error />;

  const professionItems = data.professions.map((profession) => (
    <MenuItem key={profession.id} value={profession.id}>
      {profession.name}
    </MenuItem>
  ));

  const handleSubmit = () => {
    updateUser({
      variables: {
        id,
        firstName,
        lastName,
        email,
        professionId,
      },
    });
  };

  const buttonDisabled = hasRequestedChange;
  const textClass = hasRequestedChange ? 'profile-text-item-disabled' : '';

  return (
    <>
      <div className="scrollable">
      <ProfilePharmacyModal showBanner={showBanner} setShowBanner={setShowBanner} setHasRequestedChange={setHasRequestedChange}/>
        <div className="profile-edit">
          <img 
            src={backArrow} 
            alt="back" 
            className="points-header-arrow" 
            onClick={handleBack} 
          />
          <div className="profile-edit-container">
            <div className="profile-edit-info">
              <span className="profile-edit-info-title">Persönliche Daten</span>
              <div className="profile-edit-info-details">
                <span>{data.currentUser.firstName} {data.currentUser.lastName}</span>
                <span>{`Berufsbezeichnung: ${data.currentUser.profession.name}`}</span>
                <span>{data.currentUser.email}</span>
              </div>
            </div>
            <button 
              className='profile-edit-icon'
              onClick={e => {
                e.preventDefault();
                history.push('/profile-edit');
              }}
            >
              <img 
                src={editIcon}
              />
            </button>
          </div>
          <div className="profile-edit-container-box">
            <div className="profile-edit-container">
              <div className="profile-edit-info">
                <span className={`profile-edit-info-title ${textClass}`}>Apotheke</span>
                <div className="profile-edit-info-details">
                  <span className={textClass}>{data.currentUser.pharmacy.name}</span>
                  <span className={textClass}>{data.currentUser.pharmacy.address}</span>
                  <span className={textClass}>{data.currentUser.pharmacy.zipcode} {data.currentUser.pharmacy.city}</span>
                </div>
              </div>
              <button 
                className='profile-edit-icon'
                onClick={() => setShowBanner(true)}
                disabled={buttonDisabled}
              >
                <img 
                  src={editIcon}
                />
              </button>
            </div>
            {buttonDisabled && <span className='profile-edit-request'>Antrag auf Arbeitgeberwechsel gesendet</span>}
          </div>
          <Approvals />
        </div>
      </div>
      <ModalPortal target={"modal-id"}>
        {showDelete && (
          <DeleteModal setShowDelete={setShowDelete} deleteUser={deleteUser} />
        )}
      </ModalPortal>
    </>
  );
};

export default withStyles(styles)(Edit);
